// extracted by mini-css-extract-plugin
export default {"fr-view":"Exam_fr-view__qX7Up","container":"Exam_container__um5rk","image":"Exam_image__1tCOd","title":"Exam_title__r9ijH"};